<script setup>
import { onMounted } from "vue";
import { cookiesUrl } from "@/utils/provider";
import { useCookieConsent } from "@/composables/useCookieConsent";

const { isConsentVisible, checkConsent, acceptCookies } = useCookieConsent();

onMounted(() => {
	checkConsent();
});
</script>

<template>
	<div class="cookies" v-if="isConsentVisible">
		<div class="cookies__container">
			<div class="cookies__content">
				<p>
					Данный сайт использует файлы cookies с целью безопасности, а также оптимизации и персонализации содержимого сайта и рекламы, возможности использования функций социальных сетей и анализа трафика. Если Вы остаетесь на нашем сайте, это означает, что Вы не возражаете против использования этих технологий.
					<a target="_blank" :href="cookiesUrl">Подробности.</a>
				</p>
			</div>
			<button class="btn cookies__btn --small" @click="acceptCookies">Согласиться</button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.cookies {
	position: fixed;
	width: 100%;
	left: 50%;
	bottom: 0px;
	transform: translateX(-50%);
	border-left: 1px solid var(--border-accent-2-3);
	border-right: 1px solid var(--border-accent-2-3);
	border-top: 1px solid var(--border-accent-2-3);
	border-radius: 4rem 4rem 0 0;
	backdrop-filter: blur(44.70000076293945px);
	box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14);
	background: rgba(13, 46, 26, 0.48);
	padding: 3.5rem 4rem 3.5rem;
	z-index: 3;
	@media (max-width: vars.$t) {
		// width: 95%;
	}
	@media (max-width: vars.$m) {
		padding: 1.6rem;
	}
	@media (max-width: vars.$x480) {
		padding: 1.2rem 1rem;
		border-radius: 1.4rem 1.4rem 0 0;
		// width: 95%;
	}
}
.cookies__container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2.4rem;
	@media (max-width: vars.$xx) {
		flex-direction: column;
		gap: 1.2rem;
	}
}
.cookies__content {
	max-width: 80%;
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 140%;
	@media (max-width: vars.$xx) {
		max-width: 100%;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.2rem;
	}
	a {
		white-space: nowrap;
		color: currentColor;
		border-bottom: 1px solid currentColor;
		@media (hover: hover) {
			&:hover {
				border-color: transparent;
			}
		}
	}
}

.cookies__btn {
	@media (max-width: vars.$xx) {
		width: 100%;
	}
}
</style>
